import { env } from '../config/env';
import { mockAuthService } from './mock/mockAuthService';
import { authService as apiAuthService } from './api/authService';

const useMock = env.useMockServices;

export const authService = useMock ? mockAuthService : apiAuthService;
